import { request } from "./api";
import { User, LoginCredentials, LoginResult, VerifyTokenResult, LoginData } from "@/types";

class AuthService {
  // 用户登录
  async login(credentials: LoginCredentials): Promise<LoginResult> {
    return request.post<LoginData>("/api/auth/login", credentials);
  }

  /** 企微扫码回调 code → 后端换票（转发 msOrg） */
  async wecomLogin(body: {
    code: string;
    applicationId?: string;
  }): Promise<LoginResult> {
    return request.post<LoginData>("/api/auth/wecom-login", body);
  }

  // 用户登出
  async logout(): Promise<void> {
    await request.post("/api/auth/logout");
  }

  // 验证Token（返回完整 ApiResponse，data 内含 payload）
  async verifyToken(token: string): Promise<VerifyTokenResult> {
    return request.post("/api/auth/verify", { token });
  }

  // 刷新Token
  async refreshToken(refreshToken: string) {
    return request.post("/api/auth/refresh", { refreshToken });
  }

  // 生成微服务Token
  async generateServiceToken(serviceName: string) {
    return request.post("/api/auth/service-token", { serviceName });
  }

  // 验证微服务Token
  async verifyServiceToken(token: string) {
    return request.post("/api/auth/verify-service-token", { token });
  }

  // 获取当前用户信息
  async getCurrentUser() {
    return request.get<{ user: User; permissions: string[] }>("/api/auth/me");
  }

  // 获取用户权限
  async getUserPermissions(): Promise<string[]> {
    try {
      const result = await this.getCurrentUser();
      if (result.success && result.data) {
        return result.data.permissions;
      }
      return [];
    } catch (error) {
      return [];
    }
  }

  // 检查权限
  async checkPermission(permissionCode: string): Promise<boolean> {
    try {
      const result = await request.post("/permissions/check", {
        permissionCode
      });
      return result.success && result.data?.hasPermission;
    } catch (error) {
      return false;
    }
  }
}

export const authService = new AuthService();
